import { IoCloseOutline } from "react-icons/io5";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { useMunicipioLista } from "../../../hooks/queries/municipio/useMunicipioLista/useMunicipioLista";
import { ISelectOptions } from "../../../types/inputs";

interface INeighboringCitiesFieldProps {
  label: string;
  value: string[];
  onChange: (uuids: string[]) => void;
}

/**
 * Seleção múltipla de municípios em forma de lista: cada município escolhido no
 * select é empilhado abaixo (com botão de remover) e o select volta a ficar vazio.
 * Controlado — `value`/`onChange` trafegam só os uuids, pronto para um `Controller` do RHF.
 */
export const NeighboringCitiesField = ({
  label,
  value,
  onChange,
}: INeighboringCitiesFieldProps) => {
  const { data: municipios = [] } = useMunicipioLista();

  const selecionados = value.map(
    (uuid) => municipios.find((m) => m.uuid === uuid) ?? { uuid, nome: uuid, estado: "" }
  );

  const options: ISelectOptions[] = municipios
    .filter((m) => !value.includes(m.uuid))
    .map((m) => ({ value: m.uuid, label: `${m.nome} - ${m.estado}` }));

  return (
    <div className="flex flex-col gap-4">
      <SimpleSelect
        label={label}
        options={options}
        value={null}
        onChange={(e: ISelectOptions) => e && onChange([...value, e.value])}
      />

      {selecionados.length === 0 ? (
        <p className="font-['Mulish'] text-xs text-[#9d9d9d]">
          Nenhum município selecionado
        </p>
      ) : (
        <ul className="flex flex-col gap-2">
          {selecionados.map((m) => (
            <li
              key={m.uuid}
              className="flex items-center justify-between rounded-[10px] bg-[#f7f7f7] px-4 py-2 font-['Mulish'] text-sm text-[#2d2d2d]"
            >
              <span>{m.estado ? `${m.nome} - ${m.estado}` : m.nome}</span>
              <button
                type="button"
                aria-label={`Remover ${m.nome}`}
                className="flex cursor-pointer bg-transparent"
                onClick={() => onChange(value.filter((uuid) => uuid !== m.uuid))}
              >
                <IoCloseOutline size={20} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
